'use client';
import React from 'react';
import { motion } from 'framer-motion';
import { mountAnimation } from '@/config/animation';

const AnimatedView = (props: React.PropsWithChildren) => {
  return <motion.div {...mountAnimation}>{props.children}</motion.div>;
};
export default AnimatedView;
